import * as Yup from 'yup';
//@ts-expect-error: Those instances exist
import { AnyObject, Maybe } from 'yup/lib/types';

import { validatePhoneNumber } from './validatePhoneNumber';

Yup.addMethod<Yup.StringSchema>(
  Yup.string,
  'phoneNumber',
  function (errorMessage) {
    return this.test(`phone-number`, errorMessage, function (value) {
      const { path, createError } = this;
      const isValid = validatePhoneNumber(value || '');

      return isValid || createError({ path, message: errorMessage });
    });
  }
);

declare module 'yup' {
  //@ts-expect-error: //
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
    //@ts-expect-error: //
  > extends Yup.BaseSchema<TType, TContext, TOut> {
    phoneNumber(errorMessage?: string): StringSchema<TType, TContext>;
  }
}

export const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && isFinite(value);

export default Yup;
